import wixLocation from 'wix-location';

// /************************************
//  * Global (Site) code (masterPage.js) *
//  ************************************/

// import wixStores from 'wix-stores';

// const freeSocks = "b66daae4-d996-7e75-4a15-a4d67a3ed727";
// const freeMask = "549280f5-8d87-7aa8-772b-69f9ab32578d"
// const freeHandTowels = "a783a61d-fa3e-5d5b-8e45-19f23af252b4"
// const freeKitchenTowels = "c85f684e-4e54-bfc1-83b2-a2aeedde0958"

// $w.onReady(function () {
//     wixStores.onCartChanged((cart) => {
//         console.log("cart changed")
//         console.log(cart);

//         if (cart.totals.total < 300) {
//             console.log("Cart is lower then 300")

//             // if (checkIfProductInCart(freeSocks, cart.lineItems)) {
//             //     removeProductfromCart(freeSocks, cart)
//             // } else if (checkIfProductInCart(freeMask, cart.lineItems)) {
//             //     removeProductfromCart(freeMask, cart)
//             // } else if (checkIfProductInCart(freeHandTowels, cart.lineItems)) {
//             //     removeProductfromCart(freeHandTowels, cart)
//             // } else if (checkIfProductInCart(freeKitchenTowels, cart.lineItems)) {
//             //     removeProductfromCart(freeKitchenTowels, cart)
//             // }

//             if (checkIfProductInCart("f891d0ea-3821-91b9-55c6-187b1425e1d3", cart.lineItems)) {
//                 removeProductfromCart("f891d0ea-3821-91b9-55c6-187b1425e1d3", cart)
//             }

//         } else {
//             console.log("Cart is higher then 300")
//         }
//         // const cartId = cart._id;
//         // const cartLineItems = cart.lineItems;
//     });
// });

// function checkIfProductInCart(productId, cartItems) {
//     console.log(productId)
//     console.log(cartItems)

//     var inProduct = false;

//     cartItems.forEach(function (element) {
//         if (Object.values(element).includes(productId)) {
//             console.log(productId + " exists in cart")
//             inProduct = true
//         }
//     });

//     return inProduct
// }

// function removeProductfromCart(productId, cart) {
//     console.log("removing from cart: " + productId)
//     $w('#shoppingCart').addToCart(productId, -1)
// }

export function columnStrip13_click(event) {
    wixLocation.to("/shop");
}